@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  <span>
    @if (this.asap?.value === true) {
    ASAP
    } @else if (this.control.value) {
    {{ this.control.value | date : 'mediumDate' }}
    }
  </span>
</div>
} @else {
<div class="p-0 m-0 w-100">
  <p class="rightHeadings mt-3">
    {{ title | translate }}
    @if(required){
    <span class="text-danger">*</span>
    }
  </p>
  <div class="d-flex">
    <mat-form-field appearance="outline" class="w-100 small">
      <input
        [disabled]="this.asap.value"
        [matDatepicker]="dp"
        [formControl]="control"
        placeholder="{{ 'stepperForm.examplePlaceHolders.birthDate' | translate }}"
        matInput />
      <mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #dp panelClass="example-month-picker"></mat-datepicker>
    </mat-form-field>
    <div class="d-flex flex-column">
      <input hidden="true" matInput />
      <mat-checkbox [formControl]="asap" class="button-like">ASAP</mat-checkbox>
    </div>
  </div>
</div>
}
